import SelfHelpWithdrawalLayer from "../Withdrawal/SelfHelpWithdrawalLayer";
import WithdrawalRecordLayer from "../Withdrawal/WithdrawalRecordLayer";
import WalletManagerLayer from "../Withdrawal/WalletManagerLayer";
import Constant from "../../Shared/Constant";
import Utils from "../../Shared/Utils";
import ToggleItem from "../../Common/ToggleItem";
import AudioManager from "../../Shared/AudioManager";
import EnterSoundManager from "../../Shared/EnterSoundManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WithdrawUI extends cc.Component {    
    @property(SelfHelpWithdrawalLayer)
    selfHelpWithdrawalLayer: SelfHelpWithdrawalLayer = null

    @property(WithdrawalRecordLayer)
    withdrawalRecordLayer: WithdrawalRecordLayer = null

    @property(WalletManagerLayer)
    walletManagerLayer: WalletManagerLayer = null
    
    @property(cc.Widget)
    wgtNode: cc.Widget = null

    private _chargeTypelist: Array<any> = []

    onLoad () {
        this.selfHelpWithdrawalLayer.node.active = false
        this.withdrawalRecordLayer.node.active = false
        this.walletManagerLayer.node.active = false
    }
    
    start () {
        Utils.hideGameNode()
        EnterSoundManager.playSound("enter_tixian")
    }

    onDestroy () {
    }

    onBtnClick (event, userData) {
        if (userData === "back") {
            AudioManager.playSound("close")
            Utils.showGameNode()
            this.node.destroy()
        }else if (userData === "record") {
        }
    }

    onToggleSelected (toggle: ToggleItem) {
        if (toggle.userData === "self") { 
            this.selfHelpWithdrawalLayer.node.active = true
            this.withdrawalRecordLayer.node.active = false
            this.walletManagerLayer.node.active = false
        }else if (toggle.userData === "record") {
            this.selfHelpWithdrawalLayer.node.active = false
            this.withdrawalRecordLayer.node.active = true
            this.walletManagerLayer.node.active = false
        }else if (toggle.userData === "wallet") {
            this.selfHelpWithdrawalLayer.node.active = false
            this.withdrawalRecordLayer.node.active = false
            this.walletManagerLayer.node.active = true
        }
    }
}
